'use client';
import { cn } from '@bells/core/lib/utils';
import * as React from 'react';

type Props = {
  src: string;
  className?: string;
};

const fetchSvg = async (url: string) => {
  const response = await fetch(url);

  const text = await response.text();
  // Remove the XML declaration
  const svg = text.replace(/<\?xml.*\?>/, '');
  return svg;
};

export const RemoteSVGClient = ({ src, className = '' }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (ref.current) {
      fetchSvg(src).then((svg) => {
        const element = ref.current;
        if (element) {
          element.innerHTML = svg.replace(
            '<svg',
            `<svg class="w-full h-full object-contain"`
          );
          element.querySelector('svg')?.classList.add(className);
        }
      });
    }
  }, [src, ref.current]);

  return <div ref={ref} className={cn('h-full w-full', className)}></div>;
};
